import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {mergeMap, map, catchError, flatMap, filter} from 'rxjs/operators';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';

import * as API from './api';
import * as Actions from './actions';

const fetchLists = action$ =>
    action$.pipe(
        ofType(Actions.fetchLists.type),
        mergeMap(({payload}) =>
            API.lists(payload.institutionId).pipe(
                map(response => Actions.fetchListsSuccess.action(response)),
                catchError(e => of(Actions.fetchListsFailed.action(e))),
            ),
        ),
    );

const deleteList = action$ =>
    action$.pipe(
        ofType(Actions.deleteList.type),
        flatMap(({payload}) =>
            showDeleteDialogObservable({title: i18next.t('list.confirmDelete'), type: 'mf'}).pipe(
                filter(choice => Boolean(choice)),
                flatMap(() => {
                    return API.deleteList(payload.listId).pipe(
                        map(() => Actions.deleteListSuccess.action(payload.listId)),
                        catchError(e => of(Actions.deleteListFailed.action(e))),
                    );
                }),
            ),
        ),
    );

export default combineEpics(fetchLists, deleteList);
